import { solid } from '@fortawesome/fontawesome-svg-core/import.macro';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import React from 'react';

function GolfCoursePar({ course }) {
  return (
    <article
      id="golfCoursePar"
      className="lg:h-[185px] mt-1 w-full prose prose-sm max-w-none sm:prose-md text-left grid grid-cols-4 rounded-xl bg-white shadow-lg"
    >
      <div className="flex flex-col justify-center items-center">
        <p className="text-lg font-bold text-gray-700">Holes</p>
        <FontAwesomeIcon
          icon={solid('flag')}
          className="text-sm text-indigo-600"
        />
        <p className="text-lg font-bold text-gray-700">
          {course.number_holes || '?'}
        </p>
      </div>
      <div className="flex flex-col justify-center items-center">
        <p className="text-lg font-bold text-gray-700">Par</p>
        <FontAwesomeIcon
          icon={solid('pencil')}
          className="text-sm text-indigo-600"
        />
        <p className="text-lg font-bold text-gray-700">{course.par || '?'}</p>
      </div>
      <div className="flex flex-col justify-center items-center">
        <p className="text-lg font-bold text-gray-700">Yards</p>
        <FontAwesomeIcon
          icon={solid('ruler')}
          className="text-sm text-indigo-600"
        />
        <p className="text-lg font-bold text-gray-700">
          {course.back_yardage || '?'}
        </p>
      </div>
      <div className="flex flex-col justify-center items-center">
        <p className="text-lg font-bold text-gray-700">Slope</p>
        <FontAwesomeIcon
          icon={solid('hill-rockslide')}
          className="text-sm text-indigo-600"
        />
        <p className="text-lg font-bold text-gray-700">{course.slope || '?'}</p>
      </div>
    </article>
  );
}

export default GolfCoursePar;
